// extracted by mini-css-extract-plugin
export default {"wrapper":"vo-z","response":"wo-z","error":"xo-z","disabled":"yo-z","buttons":"zo-z","feedbackQuestionSection":"Ao-z","yesNoWrapper":"Bo-z"};